<template>

	<v-tooltip bottom>
		<template v-slot:activator="{ on }">
			<div class="d-inline-block" v-on="on">

				<span v-if="linkEtherScan && tokenurl" :id="'token-' + randomId" v-bind:class="{'token-info-large': large, 'token-info': !large }">
					<a :href="tokenurl + address" target="_blank">{{ symbol }}</a>
				</span>
				<span else :id="'token-' + randomId" v-bind:class="{'token-info-large': large, 'token-info': !large }">
					<router-link :to="{ name: 'ERC20TokenPage', params: { tokenAddress: address }}">{{ symbol }}</router-link>
				</span>
<!-- 				<span v-else :id="'token-' + randomId" class="token-info">
					{{ symbol }}
				</span>
-->
			</div>
		</template>
		<div>
			<strong>{{ $t('common.token.name') }}</strong>: {{ name }}<br />
			<strong>{{ $t('common.token.symbol') }}</strong>: {{ symbol }}<br />
			<span v-if="decimals || decimals === 0 || decimals === '0'"><strong>{{ $t('common.token.decimals') }}</strong>: {{ decimals }}<br /></span>
			<span v-if="address">
				<strong>{{ $t('common.token.address') }}</strong>:<br />{{ address}}
			</span>
		</div>
	</v-tooltip>

</template>

<script>

export default {
	name: 'ERC20Token',
	props: {
    address: { type: String, required: true },
    symbol: { type: String, required: true },
    name: { type: String, required: true },
    decimals: { type: Number, required: true },
    tokenurl: { type: String },
    // showpage: { type: Boolean, default: true},
    linkEtherScan: { type: Boolean, default: false},
    large: { type: Boolean, default: false},
  },
	data () {
		return {}
	},
	computed: {
		randomId: function () {
			return Math.ceil(Math.random()*10000000000000)
		}
	},
	methods: {
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.token-info {
	/*background-color: #26a65b;*/
	background-color: #4caf50;
	padding: 6px;
	font-weight: 700;
	border-radius: 2px;
	color: #fff !important;
	margin: 2px;
}
.token-info-large {
	/*background-color: #26a65b;*/
	background-color: #4caf50;
	padding: 6px 8px;
	font-weight: 700;
	font-size: 1.20rem;
	border-radius: 2px;
	color: #fff !important;
	margin: 2px;
}
.token-info a, .token-info-large a {
	color: #FFF;
	text-decoration: none;
}
</style>
